import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import ArticleTeaser from '../../elements/article_teaser'
import Article from './article'
import {
    Alignment,
    Breadcrumb,
    Button,
    Classes,
    H5,
    Navbar,
    NavbarDivider,
    NavbarGroup,
    NavbarHeading,
} from "@blueprintjs/core";
import {withRouter} from 'react-router';
import DATA from '../../../data/article_data'

class ArticlePage extends Component {
    constructor(props){
        super(props);
        //console.log(props,this.state)
        this.state = { 
            feature_article:{
                "name":"",
                "teaser":"",
                "source": "", 
                "link":"",
                "status":"",
                "full_article":"",
                "image":"",
            },
            blog_data : DATA.blog_data,
            articles: DATA.articles,
        }
    };

    componentDidMount () {
        const { articleId } = this.props.match.params
        //console.log('id = ', articleId)
        /*
        fetch(`https://api.twitter.com/user/${handle}`)
          .then((user) => {
            this.setState(() => ({ user }))
          })
          */
         /*
         this.setState({
             feature_article: this.state.articles[articleId]
         });
         */
      }

    back_link(articleId) {
        if (articleId > 0 ){
            return <Link to={`/blog/${articleId-1}`}> <Button className={Classes.MINIMAL}  text="Back" /> </Link> ;
        }
        return  <Button className={Classes.MINIMAL} disabled={true} text="Back" /> ;
             
    };
    next_link(articleId){
        if (articleId < DATA.articles.length-1 ){
        return <Link to={`/blog/${Number(articleId)+1}`}> <Button className={Classes.MINIMAL}  text="Next" /> </Link> ;
        }
        return  <Button className={Classes.MINIMAL} disabled={true} text="Next" /> ;
    }

    // data = [{title:"demo",},{title:"demo",},{title:"demo",}]
      blog_links = DATA.articles.map(item => {
            let links = <Link to={`/blog/${item.id}`}> <Button className={Classes.MINIMAL}  text={item.id+1} /> </Link>
            return links
        });

    items = DATA.articles.map(item => {
        return <ArticleTeaser id={item.id} name={item.title} teaser={item.teaser} source={item.source} link={item.link} image={item.image}/>;
    });

  render() {
    return (
        <div className="blog_articles_page">
            
            <ul className="bp3-breadcrumbs breadcrumbs_bar">
            <li><Breadcrumb href="/" text="Home"/></li>
            <li><Breadcrumb href="/blog" text="Blog"/></li>
            <li><Breadcrumb href={`/blog/${this.state.feature_article.id}`} text={DATA.articles[this.props.match.params.articleId].title} /></li>
            </ul>
            
            <Route exact path={`/blog/:articleId`} component={Article}/>

            <div className="article_footer">
                <div className="article_controls">

                    {this.back_link(this.props.match.params.articleId )}
                    {this.blog_links}
                    {this.next_link(this.props.match.params.articleId )}
                </div>
                <div className="return_to_parent">
                    Return to parent blog page
                    <Link to="/blog">
                        <Button className={Classes.MINIMAL}  text="Back To Blog" />
                    </Link>
                </div>
            </div>

            
            <div className="blogs_list">
                <h3>Wellness Matrix Group Articles</h3>
                <ul className="flex-grid-thirds">
                    {this.items}
                </ul>
            </div>
        </div>
    );
  }
}

export default withRouter(ArticlePage);